import axios from 'axios';
import config from '../config/config';

const baseDomain = config.api_url;
const weatherDomain = 'https://api.weatherstack.com/forecast?access_key=05b7ac1484458fe61b54b4cec8781e4d&hourly=1&interval=24&query=';

export const getInfo = buildingId => axios.get(`${baseDomain}buildings/${buildingId}/widgets?fields=id,name,description,order,template,widget_params,params`, { headers: {} });
export const getInfoFoyer = alias => axios.get(`${baseDomain}foyers-display/${alias}?fields=id,name,description,order,template,widget_params,params,building`, { headers: {} });
export const getForecast = (location, days) => axios.get(`${weatherDomain}${location}&forecast_days=${days}`);

// Go through the views and
export const getWidgets = async buildingId => getInfo(buildingId).then(result => result.data);

export const getFoyers = async alias => getInfoFoyer(alias).then(result => result.data);

export const getSidebarInfo = async (city, days) => getForecast(city, days).then(result => result.data);
